/**
 * usePageDescription(slug)
 *
 * Liefert den vom Admin in den Settings hinterlegten Titel + Intro-Text
 * fuer eine Seite (events, news, rares, ...). Faellt auf die mitgegebenen
 * Default-Werte zurueck, solange das Setting noch nicht geladen ist oder
 * vom Admin nicht ueberschrieben wurde.
 * `keywords` (rotierende Schlagwoerter) kommen als Komma-String aus den
 * Settings und werden als Array geliefert (Fallback: defaults.keywords).
 */
import { useEffect, useState } from "react";
import { api } from "./api";

export const usePageDescription = (slug, defaults = {}) => {
  const [data, setData] = useState({
    eyebrow: defaults.eyebrow || "",
    title: defaults.title || "",
    intro: defaults.intro || "",
    keywords: defaults.keywords || [],
    loaded: false,
  });
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const s = await api.getSettings();
        if (!alive) return;
        const pd = (s.page_descriptions || {})[slug] || {};
        const kw = (pd.keywords || "").trim();
        setData({
          eyebrow: (pd.eyebrow || defaults.eyebrow || "").trim() || defaults.eyebrow || "",
          title: (pd.title || defaults.title || "").trim() || defaults.title || "",
          intro: (pd.intro || defaults.intro || "").trim() || defaults.intro || "",
          keywords: kw
            ? kw.split(",").map((w) => w.trim()).filter(Boolean)
            : (defaults.keywords || []),
          loaded: true,
        });
      } catch {
        if (alive) setData((p) => ({ ...p, loaded: true }));
      }
    })();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, defaults.title, defaults.intro]);
  return data;
};
